import Api from './Api';
import Configuracao from '../util/Configuracao';

class MensalidadeApi extends Api {
  async consultarMensalidades (mes, ano) {
    try {
      const mensalidadesUrl = Configuracao.getConfiguracao().mensalidadesUrl + mes + '/' + ano;
      const response = await this.fetch(mensalidadesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarValoresMensalidade (numSeqMensalidade, apenasValoresZerados) {
    try {
      const valoresMensalidadeUrl = Configuracao.getConfiguracao().valoresMensalidadeUrl + numSeqMensalidade + '/' + apenasValoresZerados;
      const response = await this.fetch(valoresMensalidadeUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirMensalidade (seqMensalidade) {
    try {
      const urlExcluirMensalidade = Configuracao.getConfiguracao().urlExcluirMensalidade + '/' + seqMensalidade;
      const response = await this.fetch(urlExcluirMensalidade, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarUltimaMensalidade () {
    try {
      const urlConsultarUltimaMensalidade = Configuracao.getConfiguracao().urlConsultarUltimaMensalidade;
      const response = await this.fetch(urlConsultarUltimaMensalidade);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirMensalidade (reajuste) {
    try {
      const urlIncluirMensalidade = Configuracao.getConfiguracao().urlIncluirMensalidade;
      const response = await this.fetch(urlIncluirMensalidade, 'put', reajuste);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async salvarValorMensalidade (valorMensalidade) {
    try {
      const urlSalvarValorMensalidade = Configuracao.getConfiguracao().urlSalvarValorMensalidade;
      const response = await this.fetch(urlSalvarValorMensalidade, 'put', valorMensalidade);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarSeguro (seqMensalidade) {
    try {
      const urlConsultarSeguro = Configuracao.getConfiguracao().urlConsultarSeguro + seqMensalidade;
      const response = await this.fetch(urlConsultarSeguro);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default MensalidadeApi;
